const defaultState = [];
export const employees = (state = defaultState, action) => {
    const {payload, type} = action;
    if (!payload) return state;
	let {employee} = payload;
    switch (type) {
        case 'EMPLOYEE_RECEIVE':
        	let index = state.findIndex(e=>e.id===employee.id);
            const newState = !employee ? null : 
                [...state.slice(0, index),
                    employee,
                    ...state.slice(index+1)];
            return newState;
        default:
            return state;
    }
}